// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar-module__wrapper","isChatBubble":"Avatar-module__isChatBubble","image":"Avatar-module__image","svgImage":"Avatar-module__svgImage"};